import { Box } from '@chakra-ui/react';
import { colors } from 'constants/constants';
import { discountText } from 'helpers/discounts';
import { useEffect, useMemo, useState } from 'react';
import { CampaignLevelTypes, CampaignsDto, Discount } from 'types/generic';

interface CampaignBannerProps {
  campaigns: CampaignsDto[];
  campaignLevel: CampaignLevelTypes;
  id?: number;
  title?: string;
}

const CampaignBanner = ({
  campaigns,
  campaignLevel,
  id,
  title,
}: CampaignBannerProps): JSX.Element => {
  // const filteredCampaign = campaigns?.filter(campaign => campaign.isActive)
  const [activeCampaigns, setActiveCampaigns] = useState<CampaignsDto[]>([]);
  const [activeDiscounts, setActiveDiscounts] = useState<Discount[]>([]);
  const [discountIndex, setDiscountIndex] = useState<number>(0);

  const filteredCampaign = useMemo(() => {
    return campaigns?.filter((c) => c.isActive) ?? [];
  }, [campaigns]);

  useEffect(() => {
    let sortedCampaigns = [];
    if (campaignLevel === 'Top') {
      sortedCampaigns = filteredCampaign?.filter(
        (campaign) => campaign.appliesToAll
      );
    } else if (campaignLevel === 'Facility') {
      sortedCampaigns = filteredCampaign?.filter((campaign) =>
        campaign.appliesToFacilityId.includes(id)
      );
    }
    setActiveCampaigns(sortedCampaigns);
  }, [id]);
  useEffect(() => {
    let sorted: CampaignsDto[] = [];

    if (campaignLevel === 'Top') {
      sorted = filteredCampaign.filter((c) => c.appliesToAll);
    } else if (campaignLevel === 'Facility' && id != null) {
      sorted = filteredCampaign.filter((c) =>
        c.appliesToFacilityId.includes(id)
      );
    }

    setActiveCampaigns(sorted);
  }, [campaignLevel, id, filteredCampaign]);

  useEffect(() => {
    const discounts = activeCampaigns.flatMap((c) => c.discounts ?? []);
    setActiveDiscounts(discounts);
  }, [activeCampaigns]);

  const titleText = (discount: Discount): string => {
    let titleText = 'JUST NU:';
    if (discount !== undefined) {
      if (campaignLevel === 'Facility' && title) {
        titleText = `JUST NU i ${title.toLocaleUpperCase()} på utvalda förråd:`;
      }
    }
    return titleText;
  };

  return (
    <>
      {activeCampaigns?.length > 0 && activeDiscounts.length && (
        <Box py={3} backgroundColor={colors.system.error[900]}>
          <Box
            color={colors.white}
            style={{ display: 'flex', justifyContent: 'center' }}>
            <Box fontWeight={600} mr={3}>
              {titleText(activeDiscounts[discountIndex])}
            </Box>{' '}
            {discountText(activeDiscounts[discountIndex])}
          </Box>
        </Box>
      )}
    </>
  );
};

export default CampaignBanner;
